
export type BaseInternalFormState = {
  loading?: boolean;
  drawerWidth?: number;
  drawerOpen: boolean;
  title: string
};

export enum ACTION_TYPES {

  setLoading = 'setLoading',
  setTitle = 'setTitle',
  setDrawerWidth = 'setDrawerWidth',
  setDrawerOpen = 'setDrawerOpen',
}

export const BaseInternalFormReducer = (state: BaseInternalFormState, action: any): BaseInternalFormState => {
  const { type, payload } = action;
  switch (type) {

    case ACTION_TYPES.setLoading:
      return {
        ...state,
        loading: payload,
      };
    case ACTION_TYPES.setDrawerWidth:
      return {
        ...state,
        drawerWidth: payload,
      };
    case ACTION_TYPES.setDrawerOpen:
      return {
        ...state,
        drawerOpen: payload,
      };
    case ACTION_TYPES.setTitle:
      return {
        ...state,
        title: payload,
      };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
}